import _ from "underscore";
import { DateTime } from "luxon";
import functionnal from "./functionnal.js";
function cleanObject(obj) {
    "use strict";
    return Object.entries(obj).reduce((result, [key, value]) => ({
        ...result,
        ...(functionnal.existy(value) && value !== "" ? { [key]: value } : null),
    }), {});
}
function removeEmptyStrings(obj) {
    return Object.entries(obj).reduce((result, [key, value]) => ({
        ...result,
        ...(value !== "" ? { [key]: value } : null),
    }), {});
}
function frenchSort(a, b) {
    "use strict";
    if (a === b) {
        return 0;
    }
    const alphabet = "._!*@()[]{}#^&%-=+01234567989aāáǎàâãąbcćčçdďðeēéěèêëęfgğhıiīíǐìîïjklłmnńňñoōóǒòôpqrřsśšştťuūúǔùůûüǖǘǚǜvwxyýzźżžþæœøõåäö";
    let i = -1;
    let aIndex, bIndex;
    a = a.toLowerCase();
    b = b.toLowerCase();
    do {
        i++;
        aIndex = alphabet.indexOf(a[i]);
        bIndex = alphabet.indexOf(b[i]);
    } while (aIndex === bIndex);
    if (aIndex - bIndex > 0) {
        return 1;
    }
    return -1;
}
const addUniqueObjToArray = (arr, obj) => {
    if (isObjectInArray(arr, obj)) {
        const idx = arr.findIndex((elem) => elem._id === obj._id);
        if (idx !== -1) {
            return arr
                .slice(0, idx)
                .concat(obj)
                .concat(arr.slice(idx + 1));
        }
        else {
            throw new Error("elem not found in addUniqueObjToArray");
        }
    }
    else {
        return [...arr, obj];
    }
};
const isObjectInArray = (arr, obj) => {
    return arr.some((objet) => objet._id === obj._id);
};
const addUniqueStringToArray = (arr, str) => {
    if (arr.indexOf(str) === -1) {
        return [...arr, str];
    }
    else {
        return arr;
    }
};
const replaceItemAtIndex = (arr, item, idx) => arr
    .slice(0, idx)
    .concat(item)
    .concat(arr.slice(idx + 1));
const getHmObjFromMinutes = (minutes) => {
    const heure = Math.floor(minutes / 60);
    const minute = minutes - heure * 60;
    return { heure, minute };
};
const addToHmObj = (hmObj, minutesOrHMObj) => {
    const initialValue = hmObj.heure * 60 + hmObj.minute;
    if (typeof minutesOrHMObj === "number") {
        return getHmObjFromMinutes(initialValue + minutesOrHMObj);
    }
    else {
        const valueToAdd = minutesOrHMObj.heure * 60 + minutesOrHMObj.minute;
        return getHmObjFromMinutes(initialValue + valueToAdd);
    }
};
const substractFromHmObj = (hmObj, minutesOrHMObj) => {
    const initialValue = hmObj.heure * 60 + hmObj.minute;
    if (typeof minutesOrHMObj === "number") {
        return getHmObjFromMinutes(initialValue - minutesOrHMObj);
    }
    else {
        const valueToSubstract = minutesOrHMObj.heure * 60 + minutesOrHMObj.minute;
        return getHmObjFromMinutes(initialValue - valueToSubstract);
    }
};
const isBeforeOrEqual = (hmObj, hmObjOrNumber) => {
    const value = hmObj.heure * 60 + hmObj.minute;
    if (typeof hmObjOrNumber === "number") {
        return value - hmObjOrNumber <= 0;
    }
    else {
        return value - (hmObjOrNumber.heure * 60 + hmObjOrNumber.minute) <= 0;
    }
};
const getWeekDays = (startDate) => {
    return _.range(0, 7).map((step) => DateTime.fromJSDate(startDate).plus({ days: step }).toJSDate());
};
const removeDuplicateId = (objs) => {
    return _.uniq(objs, (obj) => obj["_id"]);
};
const jsonDateReviver = (_key, value) => {
    // plug this regex into regex101.com to understand how it works
    // matches 2019-06-20T12:29:43.288Z (with milliseconds) and 2019-06-20T12:29:43Z (without milliseconds)
    const dateFormat = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(\.\d{1,}|)Z$/;
    if (typeof value === "string" && dateFormat.test(value)) {
        return new Date(value);
    }
    return value;
};
export { cleanObject, frenchSort, addUniqueObjToArray, addUniqueStringToArray, replaceItemAtIndex, getHmObjFromMinutes, addToHmObj, substractFromHmObj, isBeforeOrEqual, removeEmptyStrings, getWeekDays, removeDuplicateId, jsonDateReviver, };
//# sourceMappingURL=utils.js.map